enum upload {
    'choose_upload' = 'Choose files to upload',
    'download_complete' = 'Concluded, your download will start soon...',
    'download_empty' = 'Not completed, the chosen files are empty...',
    'drop_file' = 'Drop files here',
    'drop_file_upload' = 'Drop the file here to upload',
    'drop_folder' = 'Drop a folder here',
    'drop_folder_upload' = 'Drop the folder here to upload',
    'drop_or_input_file_upload' = 'Drop files here or click to upload',
    'drop_or_input_folder_upload' = 'Drop folder here or click to upload',
    'file_allowed' = 'Only file with the following extension is allowed: {ext}',
    'file_already_exists' = 'A file with this name already exists',
    'files_allowed' = 'Only files with the following extensions are allowed: {ext}',
    'files_already_exists' = 'Files with this name already exists',
    'not_file_extension' = 'Unsupported format. Please upload file in the format: {ext}!',
}

export default upload;
